import { Collection } from 'data/records'
import { resource, member, collection as c, findSelector } from 'data/helpers/apiv3'
import { fulfilled, pending } from 'lib/promiseMiddlewareHelpers'
import { getCurrentUser } from 'lib/utils'
import { Map, OrderedSet } from 'immutable'

const ADD_TO_USER_STATE = 'apiv3/collection/addToUserState'
const REMOVE_FROM_USER_STATE = 'apiv3/collection/removeFromUserState'

const [api, actions] = resource(Collection, [
  ['read', member.get('', ['privacyCode'])],
  ['list', c.get('', ['userId', 'privacyCode', 'clubId'])]
])
// FIXME these should be thunks, but we don't explicitly support those in v3resources
actions.addToUserState = (identifier, collectionId) => ({
  type: ADD_TO_USER_STATE,
  meta: {
    apiv3source: 'collection',
    identifier,
    collectionId
  }
})
actions.removeFromUserState = (identifier, collectionId) => ({
  type: REMOVE_FROM_USER_STATE,
  meta: {
    apiv3source: 'collection',
    identifier,
    collectionId
  }
})

const selectors = {
  ...findSelector(Collection),
  allForUser: (state, identifier) => state.apiv3.collection.getIn(['allForUser', identifier], OrderedSet()).map(cid => selectors.find(state, cid)).filter(Boolean)
}

const removeFromState = (state, identifier, collectionId) => {
  return state.setIn(['allForUser', identifier], state.getIn(['allForUser', identifier], OrderedSet()).delete(collectionId))
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const { identifier } = action.meta
    const nextAllForuser = state.getIn(['allForUser', identifier], OrderedSet()).concat(action.payload.results.map(r => r.id))
    return state.setIn(['allForUser', identifier], nextAllForuser)
  },
  [pending(actions.delete.type)]: (state, action) => {
    const { id } = action.meta
    const currentUserId = getCurrentUser().id
    return removeFromState(state, currentUserId, id)
  },
  [ADD_TO_USER_STATE]: (state, action) => {
    const { identifier, collectionId } = action.meta
    return state.setIn(['allForUser', identifier], state.getIn(['allForUser', identifier], OrderedSet()).add(collectionId))
  },
  [REMOVE_FROM_USER_STATE]: (state, action) => {
    const { identifier, collectionId } = action.meta
    return removeFromState(state, identifier, collectionId)
  }
}

const initialState = {
  allForUser: Map() // Map(identifier->OrderedSet([collectionIds])) where identifier is a userId or club slug
}

export {
  api as collectionApi,
  actions as collectionActions,
  selectors as collectionSelectors,
  reducers as collectionReducers,
  initialState as collectionInitialState
}
